import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=3479864a&scoped=true"
import script from "./Variable.vue?vue&type=script&lang=js"
export * from "./Variable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479864a",
  null
  
)

export default component.exports